import React, { useState } from 'react'
import ReactTooltip from 'react-tooltip'
import { Tag } from 'components'
import { formatCurrency, formatDate } from 'utils'
import { STATICS } from 'statics'
import './style.scss'

export function BillsLine({
  dueDate,
  value,
  tagText = '',
  tagColor = '',
  downloadTooltip = '',
  onDownload,
  validateDownload = () => true,
}) {
  const [isDownloading, setIsDownloading] = useState(false)

  function handleDownload() {
    setIsDownloading(true)
    onDownload()
    setIsDownloading(false)
  }

  function renderDownloadButton() {
    if (!onDownload || !validateDownload()) return null

    return (
      <button type='button' className='download' onClick={handleDownload} disabled={isDownloading}>
        <STATICS.DOWNLOAD data-for='download-tip' data-tip={downloadTooltip} />
        <ReactTooltip id='download-tip' />
      </button>
    )
  }

  return (
    <div className='bills-line'>
      <span className='info'>{formatDate(dueDate)}</span>
      <span className='info'>{formatCurrency(value)}</span>
      <div className='tag-container'>
        <span className='tag-label'>Status:</span>
        <Tag className='tag' text={tagText} color={tagColor} />
      </div>
      <div className='download-container'>{renderDownloadButton()}</div>
    </div>
  )
}
